import './BackgroundTop.scss';

const BackgroundTop = ({ color = '#58c1f5', height = '12.5rem' }) => (
  <div className='background-fixed absolute w-full' style={{ background: color, height }} />
);

export default BackgroundTop;
